/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseLangFilterViewModel } from "../types/CourseLangFilterViewModel.ts";

export const courseLangFilterViewModelSchema = z.object({
  search: z
    .string()
    .describe(
      "Texto livre aplicado ao idioma, ao nome oficial e ao nome comercial. Máximo de 200 caracteres. Opcional.",
    )
    .nullish(),
  pageNumber: z.optional(
    z.number().int().default(1).describe("Página da listagem. Mínimo 1."),
  ),
  pageSize: z.optional(
    z
      .number()
      .int()
      .default(30)
      .describe("Quantidade de itens por página. Entre 1 e 100."),
  ),
}) as unknown as ToZod<CourseLangFilterViewModel>;
